/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".custom-marker[_ngcontent-%COMP%]{color:red;background-color:#fff;font-family:\"Lucida Grande\",Arial,sans-serif;font-size:large;font-weight:700;text-align:center;width:40px;border:2px solid #000;white-space:nowrap}"];
export { styles as styles };
